module.exports = __webpack_public_path__ + "img/sowhatbuy-card-basic.778ca175.png";